import React from 'react';
import styled from 'styled-components';

import { Flex, Icons, Text, Theme } from 'baukasten';

import type { StarterSpec } from '../types';

const Pill = styled.button<{ $featured: boolean }>`
  display: flex;
  align-items: center;
  gap: ${Theme.getBaseUnit(1)};
  border: 1px solid
    ${({ $featured }) => Theme.getColor($featured ? 'lilac' : 'grey-light-100')};
  border-radius: 8px;
  background-color: ${({ $featured }) =>
    Theme.getColor($featured ? 'lilac-light' : 'white')};
  padding: ${Theme.getBaseUnit(1)} ${Theme.getBaseUnit(2)};
  cursor: pointer;

  &:hover {
    border-color: ${({ $featured }) =>
      Theme.getColor($featured ? 'lilac-dark' : 'grey-light-100')};
    background-color: ${({ $featured }) =>
      Theme.getColor($featured ? 'lilac-light' : 'grey-light-50')};
  }
`;

type Props = {
  starters: StarterSpec[];
  onPick: (message: StarterSpec['message']) => void;
};

export const ChatStarters = ({ starters, onPick }: Props) => (
  <Flex gap={1} flexWrap="wrap" justifyContent="center">
    {starters.map((starter, index) => (
      <Pill
        key={starter.label}
        type="button"
        $featured={index === 0}
        onClick={() => onPick(starter.message)}
      >
        <Icons.Assist color="lilac-dark" size="14px" noPadding />
        <Text fontSize={12} color={index === 0 ? 'lilac-dark' : 'navy'}>
          {starter.label}
        </Text>
      </Pill>
    ))}
  </Flex>
);
